export default "__VITE_ASSET__CVVIOkeA__"